import { withTheme } from '@material-ui/core';
import autoMergeLevel1 from 'redux-persist/es/stateReconciler/autoMergeLevel1';

const styles = (theme) => ({
  root: {
    position: 'fixed',
    width: '100%',
    top: 0,
    zIndex: 1000,
    [theme.breakpoints.up('md')]: {
      width: '100%',
    },
  },
  appbar: {
    boxShadow: 'none',
    backgroundColor: theme.palette.background.lighter,
  },
  underbar: {
    minHeight: 50,
    backgroundColor: theme.palette.primary.underbar,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    paddingBottom: theme.spacing.unit * 0.75,
    [theme.breakpoints.up('sm')]: {
      minHeight: 60,
    },
    [theme.breakpoints.up('md')]: {
      paddingBottom: theme.spacing.unit * 0.5,
    },
  },
  breadcrumbs: {
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    margin: '0 24px',
    [theme.breakpoints.down('sm')]: {
      margin: `0 ${theme.spacing.unit * 2}px`,
    },
    [theme.breakpoints.up('xl')]: {
      width: '1400px',
      margin: '0 auto',
    },
  },
  breadcrumbsContainer: {
    width: '100%',
  },
  toolbarWrapper: {
    width: '100%',
    boxShadow: '0 1px 8px rgba(0, 0, 0, 0.15)',
    zIndex: 1,
  },
  toolbar: {
    minHeight: '70px',
    [theme.breakpoints.up('md')]: {
      minHeight: '100px',
      height: '100%',
    },
    [theme.breakpoints.up('xl')]: {
      marginLeft: 'auto',
      marginRight: 'auto',
      padding: 0,
      width: '1400px',
    },
  },
  appbarTitle: {
    textAlign: 'left',
    fontSize: '1.5rem',
    fontWeight: 600,
    [theme.breakpoints.up('md')]: {
      fontSize: '2rem',
      borderLeftWidth: '1px',
      borderLeftStyle: 'solid',
      borderLeftColor: theme.palette.border.light,
      paddingLeft: '24px',
      marginLeft: '83px',
    },
  },
  titleBar: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  flex: {
    flex: 1,
  },
  menuButton: {
    marginLeft: `-${theme.spacing.unit * 2}px`,
    marginRight: theme.spacing.unit * 2,
    borderRight: `1px solid ${theme.palette.border.light}`,
    borderRadius: 0,
    color: theme.palette.primary.dark,
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
    '& svg': {
      fontSize: '30px',
    },
  },
  logoContainer: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  logo: {
    [theme.breakpoints.up('md')]: {
      height: 60,
      width: 198,
    },
  },
  skip: {
    color: theme.palette.text.dark,
    zIndex: 1300,
    position: 'absolute',
    top: -1000,
    left: -1000,
    '&:focus': {
      top: 0,
      left: 0,
    },
  },
  greeting: {
    color: theme.palette.text.dark,
  },
  reference: {
    color: theme.palette.text.dark,
    fontSize: '1.1875rem',
  },
  referenceLabelDesktop: {
    fontSize: '1.125rem',
    [theme.breakpoints.up('sm')]: {
      display: 'inline',
    },
    [theme.breakpoints.up('md')]: {
      fontSize: '1.1875rem',
    },
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
  referenceLabelMobile: {
    fontSize: '1.0625rem',
    [theme.breakpoints.down('xs')]: {
      display: 'inline',
    },
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  referenceValue: {
    fontWeight: 600,
  },
  logoutButton: {
    padding: '4px 60px',
    fontSize: '1.1875rem',
    fontWeight: 500,
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  appBarRight: {
    display: 'flex',
    flexDirection: 'row',
  },
});

export default styles;
